import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ComponentType, useEffect, useState } from 'react';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  background?: ComponentType;
}

const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  title,
  children,
  background: Background,
}) => {
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    if (!open) {
      onClose();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={setOpen} className="relative z-10">
      <div className="fixed inset-0" />

      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
            >
              {/* start of content */}
              {Background && <Background />}

              <div className="relative flex h-full flex-col bg-primary-100 bg-opacity-75 backdrop-blur-sm py-3 md:py-6 shadow-xl z-10">
                <div className="px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-base font-semibold text-black">
                      {title}
                    </DialogTitle>
                    <div className="flex justify-end">
                      <button
                        className="hover:text-white p-2"
                        onClick={() => setOpen(false)}
                      >
                        <XMarkIcon className="w-4 md:w-6" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="relative md:mt-6 mt-3 flex-1 px-2 sm:px-6 flex-col h-full overflow-hidden">
                  {children}
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default Drawer;
